<template>
    <AntTabs
        :default-active-key="defaultActiveTab"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <TabPane
            v-for="(tab, index) of tabs"
            :key="index"
            :tab="$t(tab)"
        >
            <slot :name="tab" />
        </TabPane>
    </AntTabs>
</template>

<script>
import { Tabs } from 'ant-design-vue';
export default {
    name: 'Tabs',
    components: {
        AntTabs: Tabs,
        TabPane: Tabs.TabPane,
    },
    props: {
        defaultActiveTab: {
            type: Number,
            default: 0,
        },
        tabs: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style>

</style>